import { render, staticRenderFns } from "./Institution.vue?vue&type=template&id=09c22217"
import script from "./Institution.vue?vue&type=script&lang=js"
export * from "./Institution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c22217')) {
      api.createRecord('09c22217', component.options)
    } else {
      api.reload('09c22217', component.options)
    }
    module.hot.accept("./Institution.vue?vue&type=template&id=09c22217", function () {
      api.rerender('09c22217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Institution.vue"
export default component.exports